// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"132":"536f1d8e","170":"341d9d3b","316":"3a416a29","520":"1713f7c1","578":"a27bdfc9","938":"025fc810"}[chunkId] + ".chunk.js";
};